import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import { Darf } from './useCreateDarfs'

export function useDeleteDarf() {
  const token = useAccessToken()
  const user = useCurrentUser()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (id: string): Promise<Darf> => {
      if (!id?.trim()) {
        throw new Error('id é obrigatório')
      }

      if (!user || !token) {
        throw new Error('Usuário não autenticado')
      }

      const response = await api.delete<Darf>(`/darfs/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      return response.data
    },
    onSuccess: data => {
      queryClient.invalidateQueries({ queryKey: ['darfs'] })

      if (data?.id_apuracao_competencia) {
        queryClient.invalidateQueries({
          queryKey: ['darfs', 'apuracao', data.id_apuracao_competencia]
        })
      }
    }
  })
}
